<template>
  <div class="video-page">
    <div class="login-header" style=" box-shadow: 1px 1px 15px rgb(0 0 0 / 10%); height: 50px;
    line-height: 70px;height: 70px;
    padding: 0 20px 0 40px;position:fixed;z-index:999;left:0;right:0;background-color:  #0D2246;height: 70px;">
      <!-- <div style="background-color: #fff; box-shadow: 1px 1px 15px rgb(0 0 0 / 10%); height: 50px;
    line-height: 60px;height: 60px;
    padding: 0 20px 0 40px;position:fixed;z-index:999;left:0;right:0;"> -->
      <div class="goBack" @click="goToBack()" style="top: 0px;"><i class="el-icon-back" style="color: #D6DFE7;"></i>
      </div>
      <el-row type="flex" justify="center" align="center">
        <el-col :xs="24">
          <div class="headerMain">
            <div style="display:flex;">
              <!-- <img src="@/assets/img/logo.jpg" alt="logo" style="width: 60px ;height:60px;" />
              <div class="headerTop">考试视频回放</div> -->
              <img :src="headerLogo" alt="logo"
                style="width: 597px ;height:36px;line-height: 70px;margin-top: 15px;" />
              <!-- <img src="@/assets/addImg/logo2.png" alt="logo"
                style="width: 597px ;height:36px;line-height: 70px;margin-top: 15px;" /> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div style="height: 70px;"></div>

    <div style="display:flex;justify-content: center;align-items: center;">
      <div v-for="(tab, index) in tabList" :key="index" :style="{
        width: '130px',
        height: '48px',
        margin: '20px 8px',
        textAlign: 'center',
        position: 'relative',
        cursor: 'pointer',
        color: tab.selected ? '#75FFF7' : 'inherit',
      }" @click="selectTab(index)">
        <img :src="tab.selected ? tabActiveImage : tabDefaultImage" alt="icon"
          style="width: 100%; height: 100%; vertical-align: middle;" />
        <span style="vertical-align: middle;position: absolute;left:0;right:0;top:14px;">{{ tab.name }}</span>
      </div>

    </div>

    <div v-show="videoLength == 1">
      <div v-for="(video, idx) in videos" :key="idx">
        <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1" :class="{ 'is-portrait': video.portrait }"
          style="margin-top: 120px !important;">
          <el-image class="thumbnail" :fit="video.portrait ? 'contain' : 'cover'" :src="video.thumbnail"
            :style="portraitStyle(video, 0.58)" @click.native="openMediaDialog(video)"></el-image>
          <div class="video-name">{{ video.name }}</div>
        </div>
        <div v-else class="thumbnail-container bg_img_1" :class="{ 'is-portrait': video.portrait }"
          style="margin-top: 120px !important; " @click="openMediaDialog(video)">
          <img :src="video.thumbnail" class="thumbnail" :style="portraitStyle(video, 0.58)" />
          <div class="video-name">{{ video.name }}</div>
        </div>
      </div>
    </div>

    <div v-show="videoLength == 2" style="display:flex;justify-content: center;align-items: center;column-gap: 48px;">
      <div v-for="(video, idx) in videos" :key="idx">
        <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1" :class="{ 'is-portrait': video.portrait }"
          style="width: 100%;">
          <el-image class="thumbnail" :fit="video.portrait ? 'contain' : 'cover'" :src="video.thumbnail"
            :style="portraitStyle(video, 0.52)" @click.native="openMediaDialog(video)"></el-image>
          <div class="video-name">{{ video.name }}</div>
        </div>
        <div v-else class="thumbnail-container bg_img_1" :class="{ 'is-portrait': video.portrait }"
          style="width: 100%;" @click="openMediaDialog(video)">
          <img :src="video.thumbnail" class="thumbnail" :style="portraitStyle(video, 0.52)" />
          <div class="video-name">{{ video.name }}</div>
        </div>
      </div>
    </div>

    <swiper v-if="videoLength > 2" :options="swiperOptions" ref="mySwiper" style="margin-top: 10px;" :key="swiperKey">
      <swiper-slide v-for="(video, idx) in videos" :key="idx">
        <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1" :class="{ 'is-portrait': video.portrait }"
          style="margin-top: 40px;width:100%;">
          <el-image class="thumbnail" :fit="video.portrait ? 'contain' : 'cover'" :src="video.thumbnail"
            :style="portraitStyle(video, 0.4)" @click.native="openMediaDialog(video)"></el-image>
          <div class="video-name">{{ video.name }}</div>
        </div>
        <div v-else class="thumbnail-container bg_img_1" :class="{ 'is-portrait': video.portrait }"
          style="margin-top: 40px;width:100%;" @click="openMediaDialog(video)">
          <img :src="video.thumbnail" class="thumbnail" :style="portraitStyle(video, 0.4)" />
          <div class="video-name">{{ video.name }}</div>
        </div>
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>


    <el-tabs v-model="activeTab" @tab-click="handleTabClick" style="margin-top: 10px;" v-show="false">
      <el-tab-pane v-for="(tab, index) in tabs" :key="index" :label="tab" :name="String(index)">
        <el-row :gutter="20">
          <el-col v-for="(video, idx) in videos" :key="idx" :xs="24" :sm="12" :md="8" :lg="6" :xl="4"
            class="video-item">
            <div v-if="video.type === 'image'" class="thumbnail-container bg_img_1">
              <el-image class="thumbnail" fit="cover" :src="video.thumbnail" :preview-src-list="[video.thumbnail]">
              </el-image>
              <div class="video-name">{{ video.name }}</div>
            </div>
            <div v-else class="thumbnail-container bg_img_1" @click="openMediaDialog(video)">
              <img :src="video.thumbnail" class="thumbnail" />
              <div class="video-name">{{ video.name }}</div>
            </div>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog :visible.sync="dialogVisible" :fullscreen="true" :show-close="true" :close-on-click-modal="true"
      custom-class="media-preview-dialog" @close="handleDialogClose">
      <div class="dialog-video-container">
        <div v-show="hasPrev" class="media-nav media-nav-prev" @click="switchMedia(-1)">
          <i class="el-icon-arrow-left"></i>
        </div>
        <div v-show="hasNext" class="media-nav media-nav-next" @click="switchMedia(1)">
          <i class="el-icon-arrow-right"></i>
        </div>
        <img v-if="selectedVideo && selectedVideo.type === 'image'" :src="selectedVideo.url" class="dialog-image" />
        <video v-else ref="videoPlayer" :key="selectedVideo ? selectedVideo.url : 'empty'" :src="selectedVideo?.url"
          :crossorigin="cyMode ? undefined : 'anonymous'"
          controls autoplay class="dialog-video"
          :class="{ 'is-portrait-video': selectedVideo && selectedVideo.videoPortrait }"
          @ended="onVideoEnded"></video>
      </div>
    </el-dialog>

    <!-- 媒体本地缓存入口（仅北京模式渲染；cy 模式零接触：无按钮、无同步、无 crossorigin） -->
    <div v-if="!cyMode" class="media-cache-entry">
      <el-tooltip :content="cacheBtnTooltip" placement="left">
        <div class="media-cache-btn" @click="cachePanelVisible = !cachePanelVisible">
          <div class="cache-ring" v-show="cacheUI.status === 'syncing' || cacheUI.status === 'checking'"
            :style="{ background: 'conic-gradient(#75FFF7 ' + cacheUI.percent + '%, rgba(255,255,255,0.18) 0)' }">
            <div class="cache-ring-hole"><i class="el-icon-download"></i></div>
          </div>
          <i v-show="cacheUI.status !== 'syncing' && cacheUI.status !== 'checking'" class="el-icon-download"></i>
        </div>
      </el-tooltip>

      <div v-show="cachePanelVisible" class="media-cache-panel">
        <div class="cache-panel-title">本地媒体缓存</div>
        <div class="cache-panel-row" v-if="cacheUI.total">
          已缓存 {{ cacheUI.done }} / {{ cacheUI.total }} 个文件
          <span v-if="cacheUI.status === 'syncing' || cacheUI.status === 'checking'">· 正在同步</span>
          <span v-else-if="cacheUI.status === 'paused'">· 已暂停</span>
          <span v-else-if="cacheUI.failCount" class="cache-fail-note">· 有 {{ cacheUI.failCount }} 个失败项（详见控制台）</span>
          <span v-else-if="cacheUI.status === 'done' && cacheUI.done >= cacheUI.total">· 已是最新</span>
        </div>
        <div class="cache-panel-row current" v-if="cacheUI.current" :title="cacheUI.current">{{ cacheUI.current }}</div>
        <el-progress v-if="cacheUI.total" :percentage="cacheUI.percent" :stroke-width="10"
          :show-text="false" color="#75FFF7"></el-progress>
        <div class="cache-panel-row small" v-if="cacheUI.bytesText">{{ cacheUI.bytesText }}</div>
        <div class="cache-panel-row small" v-if="cacheUI.storageText">{{ cacheUI.storageText }} · 持久化：{{ cacheUI.persistedText }}</div>
        <div class="cache-panel-row warn" v-if="cacheUI.quotaRisk">可用空间可能不足，若同步中断请检查 Chrome「关闭所有窗口时清除 Cookie」设置</div>
        <div class="cache-panel-row warn" v-if="cacheUI.offline">离线模式：清单为最近一次缓存版本</div>
        <div class="cache-panel-actions">
          <el-button size="mini" type="primary"
            v-if="cacheUI.status === 'idle' || cacheUI.status === 'done'"
            @click="startCacheSync">开始同步</el-button>
          <el-button size="mini" v-if="cacheUI.status === 'syncing' || cacheUI.status === 'checking'"
            @click="pauseCacheSync">暂停</el-button>
          <el-button size="mini" type="primary" v-if="cacheUI.status === 'paused'"
            @click="resumeCacheSync">继续</el-button>
          <el-button size="mini" type="danger" plain v-if="cacheUI.done > 0" @click="clearCacheSync">清空缓存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/swiper-bundle.min.css'; // 引入核心样式
// import { Swiper, SwiperSlide } from 'swiper';
// // import 'swiper.less';

import tabDefaultImage1 from '@/assets/addImg/video-play/t0.png';
import tabDefaultImage2 from '@/assets/addImg/video-play/t1.png';
import logo1Image from '@/assets/addImg/logo1.png';
import logo2Image from '@/assets/addImg/logo2.png';
import mediaCache from './mediaCache';

export default {
  name: 'VideoPlay',
  // comments: {
  //   Swiper,
  //   SwiperSlide,
  // },
  computed: {
    headerLogo() {
      // cy 模式使用 logo2.png，否则使用 logo1.png
      return this.cyMode ? logo2Image : logo1Image;
    },
    swiper() {
      return this.$refs.mySwiper.swiper
    },
    hasPrev() {
      return this.videos.indexOf(this.selectedVideo) > 0;
    },
    hasNext() {
      const idx = this.videos.indexOf(this.selectedVideo);
      return idx !== -1 && idx < this.videos.length - 1;
    },
    cacheBtnTooltip() {
      const s = this.cacheUI;
      if (s.status === 'syncing' || s.status === 'checking') return `媒体同步中 ${s.percent}%`;
      if (s.status === 'paused') return '媒体同步已暂停';
      if (s.status === 'done' && s.total && s.done >= s.total) return '本地缓存已是最新（点击查看）';
      return '同步媒体到本地缓存（点击查看）';
    },
  },
  data() {
    return {
      // 朝考通模式：使用 logo2.png
      cyMode: false,
      tabDefaultImage: tabDefaultImage1,
      tabActiveImage: tabDefaultImage2,
      tabList: [],
      vList: [],
      videoLength: 0,
      swiperKey: 0,
      swiperOptions: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: true,
        // loop: true,
        // slidesPerGroup: 3,
        // loop: true,
        // observer: true,
        // observeParents: true,
        // loopFillGroupWithBlank: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        //  on: {
        //   // 监听 slide 创建事件
        //   slideChange: function () {
        //     // 确保内容正确渲染
        //     this.$nextTick(() => {
        //       this.updateLoopSlides();
        //     });
        //   },
        // },
      },
      swiperInstance: null,
      // tab 标签
      tabs: [
        // '1.考务会',
        // '2.试卷清点',
        // '3.试卷发放',
        // '4.入场核验',
        // '5.调度画面',
        // '6.收卷',
        // '7.突发',
      ],
      activeTab: '0', // 默认激活第一个 tab
      videos: [], // 当前 tab 下的视频列表
      selectedVideo: null, // 当前选中的视频
      configData: null,
      dialogVisible: false, // 控制弹框是否显示
      // —— 媒体本地缓存（仅北京模式；cy 模式无按钮零接触）——
      cachePanelVisible: false,
      cacheUI: {
        status: 'idle', // idle | checking | syncing | paused | done
        total: 0,
        done: 0,
        okCount: 0,
        skipCount: 0,
        failCount: 0,
        percent: 0,
        current: '',
        bytesText: '',
        storageText: '',
        persistedText: '未申请',
        quotaRisk: false,
        offline: false,
      },
    };
  },
  methods: {
    updateLoopSlides() {
      const swiper = this.$refs.mySwiper?.swiper;
      if (!swiper) return;

      // 获取所有 slide 元素
      const slides = swiper.slides;

      // 遍历所有 slide（包括复制的 slide）
      slides.forEach((slide, index) => {
        // 获取原始数据索引（假设原始数据长度为 originalLength）
        const originalIndex = index % this.videos.length;

        // 更新 slide 内容（根据业务逻辑动态填充）
        const slideContent = slide.querySelector('.thumbnail-container');
        if (slideContent) {
          // 重新绑定数据（如 video.name）
          slideContent.querySelector('.video-name').innerText = this.videos[originalIndex]?.name || '';
        }
      });
    },
    selectTab(index) {
      this.tabList.forEach((tab, i) => {
        tab.selected = i === index;
      });
      this.loadVideos(index);
    },
    // 竖版资源：按原始比例完整显示，不裁切、不拉伸、不放大超过原生分辨率
    portraitStyle(video, maxHeightRatio) {
      if (!video.portrait || !video.naturalWidth || !video.naturalHeight) return {};
      const viewportCap = Math.round(window.innerHeight * maxHeightRatio);
      const h = Math.min(viewportCap, video.naturalHeight);
      const w = Math.round(h * (video.naturalWidth / video.naturalHeight));
      return {
        width: `${w}px`,
        height: `${h}px`,
        maxWidth: '100%',
        objectFit: 'contain',
      };
    },
    // 检测列表中媒体的原始宽高，判断是否为竖版
    // 图片取图片本身；视频取封面图（封面即列表展示内容）
    detectMediaRatio(item) {
      return new Promise(resolve => {
        const img = new Image();
        img.onload = () => {
          this.$set(item, 'naturalWidth', img.naturalWidth);
          this.$set(item, 'naturalHeight', img.naturalHeight);
          this.$set(item, 'portrait', img.naturalHeight > img.naturalWidth);
          resolve();
        };
        img.onerror = () => resolve();
        img.src = item.type === 'image' ? item.url : item.thumbnail;
      });
    },
    // 检测视频原始宽高比（弹窗播放时判断竖版）
    detectVideoRatio(item) {
      return new Promise(resolve => {
        const videoEl = document.createElement('video');
        videoEl.preload = 'metadata';
        videoEl.muted = true;
        // SW 缓存媒体要求 CORS 模式（同源也必须加），且必须在赋 src 之前设置；cy 模式保持原行为
        if (!this.cyMode) videoEl.crossOrigin = 'anonymous';
        videoEl.onloadedmetadata = () => {
          this.$set(item, 'videoPortrait', videoEl.videoHeight > videoEl.videoWidth);
          resolve();
        };
        videoEl.onerror = () => resolve();
        videoEl.src = item.url;
      });
    },
    goToBack() {
      this.$router.go(-1);
    },
    openMediaDialog(media) {
      if (!media) return;
      this.selectedVideo = media;
      this.dialogVisible = true;
      // 同步进行中打开弹窗：自动暂停下载避免抢带宽，关闭弹窗后自动恢复
      if (!this.cyMode) mediaCache.autoPause();
      // 竖版视频在弹窗内按原始比例完整显示
      if (media.type !== 'image' && media.videoPortrait === undefined) {
        this.detectVideoRatio(media);
      }
    },
    // 全屏预览内切换上一个/下一个媒体（图片、视频混合切换）
    switchMedia(step) {
      const idx = this.videos.indexOf(this.selectedVideo);
      if (idx === -1) return;
      const nextIdx = idx + step;
      if (nextIdx < 0 || nextIdx >= this.videos.length) return;
      const media = this.videos[nextIdx];
      this.selectedVideo = media;
      if (media.type !== 'image' && media.videoPortrait === undefined) {
        this.detectVideoRatio(media);
      }
      if (media.type !== 'image') {
        this.$nextTick(() => {
          const videoPlayer = this.$refs.videoPlayer;
          if (videoPlayer && videoPlayer.play) {
            const p = videoPlayer.play();
            if (p && p.catch) p.catch(() => {});
          }
        });
      }
    },
    // 弹窗打开时支持键盘左右键切换
    handleKeydown(e) {
      if (!this.dialogVisible) return;
      if (e.key === 'ArrowLeft') {
        this.switchMedia(-1);
      } else if (e.key === 'ArrowRight') {
        this.switchMedia(1);
      }
    },

    // 关闭弹框时停止播放
    handleDialogClose() {
      const videoPlayer = this.$refs.videoPlayer;
      if (videoPlayer) {
        videoPlayer.pause(); // 停止播放
      }
      this.selectedVideo = null;
      // 弹窗关闭：恢复因打开弹窗而自动暂停的同步
      if (!this.cyMode) mediaCache.autoResume();
    },

    // 可选：视频结束时处理
    onVideoEnded() {
      console.log('视频已结束');
    },
    loadConfig() {
      const configUrl = this.cyMode ? '/videos_cy/config.json' : '/videos/config.json';

      fetch(configUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error('网络响应失败');
          }
          // SW 离线回退标记（仅北京 SW 会附加此头，表示清单来自本地缓存而非服务器）
          if (!this.cyMode) {
            const offline = response.headers.get('X-VL-Offline') === '1';
            this.cacheUI.offline = offline;
            mediaCache.setOffline(offline);
          }
          return response.json();
        })
        .then(data => {
          console.log('读取到的配置:', data);
          // 处理你的数据
          this.configData = data;

          // 将 configData 中的 description 赋值给 tabs
          this.tabs = data.map(item => item.description);

          data.forEach((item, index) => {
            this.tabList.push({
              name: item.description,
              selected: index === 0 || false, // 默认选中第一个 tab
            });
          });

          this.loadVideos(0); // 初始化加载第一个 tab 的视频

          // 初始化本地缓存统计（仅统计已缓存条目，不发起任何下载）
          if (!this.cyMode) mediaCache.init(data, this.onCacheProgress);
        })
        .catch(error => {
          console.error('读取 config.json 失败:', error);
        });
    },
    // 获取当前 tab 对应的视频目录
    getVideoDir(tabIndex) {
      return this.cyMode ? `/videos_cy/${parseInt(tabIndex) + 1}` : `/videos/${parseInt(tabIndex) + 1}`;
    },

    // 加载视频列表
    loadVideos(tabIndex = 0) {
      const dir = this.getVideoDir(tabIndex);
      console.log(`加载视频目录11: ${dir}`)
      // configData 数据为
      // [
      //   {
      //     "dirname": "1",
      //     "description": "考务会",
      //     "files": [
      //       {
      //         "name": "24216-340670744_tiny",
      //         "path": "/videos/1/24216-340670744_tiny.mp4"
      //       },
      //       {
      //         "name": "74888-553838564_large",
      //         "path": "/videos/1/74888-553838564_large.mp4"
      //       }
      //     ]
      //   }
      // ]



      console.log('122', this.configData)
      const dirData = this.configData.find(item => item.dirname === (parseInt(tabIndex) + 1).toString());
      if (dirData) {
        // this.videos = dirData.files.map(file => ({
        //   name: file.name,
        //   url: file.path,
        //   thumbnail: '/default-thumbnail.jpg', // 可替换为动态生成缩略图
        // })); 

        const videosWithThumbnails = dirData.files.map(file => {
          console.log('file:', file)
          if (file.thumbnail) {
            return {
              name: file.name,
              url: file.path,
              thumbnail: file.thumbnail,
              type: file.type || 'video', // 添加 type 字段，默认为 video
            };
          } else {
            const video = {
              name: file.name,
              url: file.path,
              thumbnail: '',
              type: file.type || 'video',
            };

            const videoElement = document.createElement('video');
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            videoElement.src = video.url;

            videoElement.addEventListener('loadeddata', () => {
              videoElement.currentTime = 0;
            });

            videoElement.addEventListener('seeked', () => {
              canvas.width = videoElement.videoWidth;
              canvas.height = videoElement.videoHeight;
              ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
              const thumbnail = canvas.toDataURL('image/png');

              // 更新对应的视频对象
              this.videos = this.videos.map(v =>
                v.name === video.name ? { ...v, thumbnail } : v
              );
            });

            return video;
          }
        });

        // this.videos = videosWithThumbnails;

        this.$set(this, 'videos', videosWithThumbnails);

        // 检测每项媒体原始宽高，竖版按原比例自适应显示
        Promise.all(videosWithThumbnails.map(v => this.detectMediaRatio(v))).then(() => {
          this.$set(this, 'videos', [...videosWithThumbnails]);
        });

        console.log('加载的视频列表:', this.videos);
        console.log('数量:', this.videos.length);
        this.videoLength = this.videos.length;

        this.vList = []
        this.$set(this, 'vList', videosWithThumbnails);
        console.log('vList:', this.vList);
        console.log('vList leng :', this.vList.length);

        this.swiperKey++; // 更新 key 强制刷新 Swiper
        console.log('swiperKey:', this.swiperKey);
        // this.$nextTick(() => {
        //   if (this.$refs.mySwiper) {
        //     this.$refs.mySwiper.update(); // 手动刷新 Swiper
        //     console.log(111)
        //     setTimeout(() => {
        //       this.updateLoopSlides()    
        //     }, 50)
            
        //   }
        // });


      }

      // fetch(dir)
      //   .then(async (res) => {
      //     console.log('res:', res);
      //     if (res.status === 404) {
      //       console.warn(`目录不存在: ${dir}`);
      //       this.videos = [];
      //       return;
      //     }
      //     const html = await res.text();
      //     console.log('html:', html);
      //     const parser = new DOMParser();
      //     const doc = parser.parseFromString(html, 'text/html');
      //     const links = Array.from(doc.querySelectorAll('a'))
      //       .map((a) => a.getAttribute('href'))
      //       .filter((href) => href?.endsWith('.mp4'));

      //     console.log('links:', links)

      //     this.videos = links.map((file) => ({
      //       name: file,
      //       url: `${dir}/${file}`,
      //       thumbnail: '/default-thumbnail.jpg', // 可替换为动态生成缩略图
      //     }));
      //   })
      //   .catch((err) => {
      //     console.error('加载视频失败:', err);
      //     this.videos = [];
      //   });
    },

    // 切换 tab
    handleTabClick(tab) {
      this.loadVideos(parseInt(tab.name));
    },

    // 播放视频
    playVideo(video) {
      this.selectedVideo = video;
    },

    // —— 媒体本地缓存（仅北京模式）——
    onCacheProgress(s) {
      // 引擎快照合并进面板状态（offline 由页面侧管理，快照不含该键、自动保留）
      this.cacheUI = Object.assign({}, this.cacheUI, s);
    },
    startCacheSync() {
      mediaCache.start(this.configData, this.onCacheProgress);
    },
    pauseCacheSync() {
      mediaCache.pause();
    },
    resumeCacheSync() {
      mediaCache.resume();
    },
    clearCacheSync() {
      this.$confirm('确定清空本地媒体缓存？清空后回到联网模式播放。', '提示', {
        confirmButtonText: '清空',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        mediaCache.clearAll();
      }).catch(() => {});
    },
  },
  created() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  mounted() {
    // 朝考通模式检测
    this.cyMode = this.$route.query.p === 'cy' || sessionStorage.getItem('cy_mode') === '1';
    if (this.$route.query.p === 'cy') sessionStorage.setItem('cy_mode', '1');

    this.loadConfig();

    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
    // 离开页面时释放同步锁（进行中的下载由引擎继续完成或随页面销毁终止）
    if (!this.cyMode) mediaCache.release();
  },
};
</script>

<style lang="scss">
.video-page {
  .el-tabs__item {
    font-size: 16px !important;
    color: #CDD6E3 !important;
  }

  .el-tabs__item.is-active {
    color: #3876ff !important;
  }
}

/* 全屏预览弹窗：纯黑底贴边（避免白边），header 只留关闭按钮并压缩高度，body 占满剩余空间不出滚动条 */
.media-preview-dialog {
  display: flex;
  flex-direction: column;
  /* Element 的 is-fullscreen 自带 overflow:auto，内容有细微溢出就会出竖向滚动条 */
  overflow: hidden !important;
  background: #000;

  .el-dialog__header {
    padding: 8px 12px;
  }

  .el-dialog__headerbtn {
    .el-dialog__close {
      color: rgba(255, 255, 255, 0.85);

      &:hover {
        color: #fff;
      }
    }

    /* 关闭按钮要压在内容容器(dialog-video-container 是定位元素)之上，否则被盖住点不到 */
    z-index: 10;
    top: 4px;
    right: 8px;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
  }

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    padding: 0;
    overflow: hidden;
  }
}
</style>
<style scoped>
.video-page {
  width: 100%;
  height: 100%;
  /* overflow: hidden; */
  background-image: url('../../assets/addImg/video-play/bg1.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.swiper-container {
  width: 100%;
  height: 600px;
}

.swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  /* background: #fff; */

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(0.8);
  /* transform: scale(1); */

  padding: 0 0 !important;
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  /* transform: scale(1.1); */
  transform: scale(1);
}

.video-page {
  padding: 0 20px 20px 20px;
  color: #CDD6E3;
}

.thumbnail-container {
  text-align: center;
  cursor: pointer;
  margin-bottom: 15px;
  /* border: 2px solid yellow; */
  /* margin-top: 100px; */
}

.bg_img_1 {
  width: 33%;
  /* height: 480px; */
  height: 420px;
  margin: 0 auto;
  /* border: 2px solid red; */

  /* background-image: url('../../assets/addImg/video-play/bg2.png');
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat; */

  margin-top: 40px !important;
}

.thumbnail {
  width: 100%;
  /* height: auto; */
  /* height: 440px; */
  height: 420px;
  /* height: 300px; */
  /* border-radius: 8px;
  padding-top: 100px;
  padding-left: 36px;
  padding-bottom: 46px;
  padding-right: 40px; */
  /* box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); */
  /* border: 2px solid red; */
}

/* 竖版资源：容器按内容宽度收缩并居中，媒体本身保持原始比例完整显示 */
.is-portrait {
  width: fit-content !important;
  height: auto !important;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.is-portrait .thumbnail {
  object-fit: contain;
}

.is-portrait .video-name {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
  padding-left: 20px;
  padding-right: 20px;
}

.video-name {
  margin-top: 20px;
  font-size: 18px;
  color: #00E8F9;
  padding-top: 26px;

  text-align: center;
  /* width: 33%; */
  width: 80%;
  height: 80px;
  margin: 0 auto;
  /* border:1px solid red; */
  /* border: 2px solid red; */

  /* background-image: url('../../assets/addImg/video-play/bg31.png'); */
  /* background-size: contain;
  background-position: center;
  background-repeat: no-repeat; */

  /* margin-top: 20px !important; */
}

.video-player {
  margin-top: 30px;
}

.player {
  width: 100%;
  max-width: 800px;
  height: auto;
}

.dialog-video-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.media-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.45);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  cursor: pointer;
  z-index: 10;
  user-select: none;
}

.media-nav:hover {
  background: rgba(0, 0, 0, 0.75);
}

.media-nav-prev {
  left: 24px;
}

.media-nav-next {
  right: 24px;
}

.dialog-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.dialog-video {
  width: 100%;
  height: 100%;
  /* 完整显示视频内容不裁切（cover 会把左右/上下边缘裁掉，笔记本小屏上字幕等边缘内容丢失）；
     比例不符时留出的空边由弹窗黑底填充 */
  object-fit: contain;
  display: block;
}

/* 竖版视频：保持原始比例完整显示，不裁切 */
.is-portrait-video {
  width: auto !important;
  height: 100%;
  max-width: 100%;
  object-fit: contain;
}

/* —— 媒体本地缓存入口（仅北京模式渲染；右上角半透明，hover 变清晰） —— */
.media-cache-entry {
  position: fixed;
  top: 15px;
  right: 24px;
  z-index: 1001;
}

.media-cache-btn {
  position: relative;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(13, 34, 70, 0.55);
  border: 1px solid rgba(117, 255, 247, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: 0.2;
  transition: opacity 0.2s;
  font-size: 13px;
  color: #75FFF7;
}

.media-cache-btn:hover {
  opacity: 0.95;
}

/* 同步进行中：图标外圈进度环（conic-gradient 动态百分比） */
.cache-ring {
  position: absolute;
  inset: -1px;
  border-radius: 50%;
}

.cache-ring-hole {
  position: absolute;
  inset: 2px;
  border-radius: 50%;
  background: #0D2246;
  display: flex;
  align-items: center;
  justify-content: center;
}

.media-cache-panel {
  position: absolute;
  top: 36px;
  right: 0;
  width: 300px;
  background: rgba(10, 25, 52, 0.96);
  border: 1px solid rgba(117, 255, 247, 0.3);
  border-radius: 8px;
  padding: 14px;
  color: #CDD6E3;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.cache-panel-title {
  font-size: 14px;
  color: #fff;
  margin-bottom: 8px;
  font-weight: 600;
}

.cache-panel-row {
  font-size: 12px;
  margin: 6px 0;
}

.cache-panel-row.current {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #75FFF7;
}

.cache-panel-row.small {
  color: #8fa3bd;
}

.cache-panel-row.warn {
  color: #E6A23C;
}

.cache-fail-note {
  color: #E6A23C;
}

.cache-panel-actions {
  margin-top: 10px;
  display: flex;
  gap: 8px;
}
</style>